import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';

import { Heading2, Flex } from '@sopranodesign/pulse-components';

import { useChartColours, useMetric } from '../../../hooks/index';

const LineGraphMetric = () => {
  Chart.register(...registerables);

  const { metric } = useMetric();

  const colours = useChartColours();

  return (
    <Flex col pad="true" tall>
      <Heading2>{metric.data.label}</Heading2>
      <Flex tall>
        <Line
          options={{ animations: false, maintainAspectRatio: false }}
          data={{
            labels: metric.data.data.labels,
            datasets: metric.data.data.datasets.map((set, key) => ({
              ...set,
              borderColor: colours(
                metric.data.data.length,
                metric.data.data.datasets.length
              )[key]
            }))
          }}
        />
      </Flex>
    </Flex>
  );
};

export default LineGraphMetric;
